// Lightweight storage service for upload & folder creation
// Uses fetch with credentials to hit backend API

export const uploadsEnabled = (process.env.REACT_APP_ENABLE_UPLOADS || 'true') !== 'false';

const jsonHeaders = () => ({ 'Content-Type': 'application/json' });

export async function createJob(jobId) {
  const res = await fetch('/api/Storage/jobs', {
    method: 'POST',
    headers: { ...jsonHeaders() },
    credentials: 'include',
    body: JSON.stringify({ jobId })
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json(); // { jobId, serverPath }
}

export async function uploadFiles({ jobId, files }) {
  const fd = new FormData();
  if (jobId) fd.append('jobId', jobId);
  (files || []).forEach(f => fd.append('files', f, f.name));
  const res = await fetch('/api/Storage/upload', { method: 'POST', body: fd, credentials: 'include' });
  if (!res.ok) throw new Error(await res.text());
  return res.json(); // { storedCount, jobId, serverPath }
}

export async function createFolder({ parentPath, jobId, name }) {
  const res = await fetch('/api/Storage/folder', {
    method: 'POST',
    headers: { ...jsonHeaders() },
    credentials: 'include',
    body: JSON.stringify({ parentPath, jobId, name })
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json(); // { serverPath }
}


